import React from 'react';

import { TypographyListItem } from '@gogame/components';

import ActionStatus from './ActionStatus';

export const Approver = ({
  children,
  name,
  role,
  signStatus,
  isPredicted,
  ...props
}) => {
  return (
    <TypographyListItem
      {...props}
      icon={isPredicted ? null : <ActionStatus actionId={signStatus} />}
    >
      {name || role}
    </TypographyListItem>
  );
};

export default Approver;
